import httpUtils from '../utils/http-utils';
import { API_PATH } from '../config/app-config';

// NMU-608: ทางลัดด่วน — /api/v1/admin/quick-links
const SERVICE_NAME = API_PATH.QUICK_LINK;

const list = () => httpUtils.get(SERVICE_NAME);

const add = (bean) => httpUtils.post(SERVICE_NAME, bean);

const edit = (id, bean) => httpUtils.put(`${SERVICE_NAME}/${encodeURIComponent(id)}`, bean);

const remove = (id) => httpUtils.del(`${SERVICE_NAME}/${encodeURIComponent(id)}`);

const quickLinkApi = { list, add, edit, remove };

export default quickLinkApi;
